import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Loader2 } from "lucide-react";
import { Header } from "../components/Header";
import { adminLogin } from "../lib/api";
import { ADMIN } from "../constants/testIds";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const res = await adminLogin(email, password);
      localStorage.setItem("sbi_admin_token", res.token);
      localStorage.setItem("sbi_admin_email", res.email);
      navigate("/admin/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header minimal />
      <main className="flex-1 flex items-center justify-center px-5">
        <div className="w-full max-w-md">
          <div className="text-center mb-7">
            <div className="inline-flex w-12 h-12 items-center justify-center rounded-2xl bg-emerald-500/10 border border-emerald-500/30 mb-4">
              <ShieldCheck className="w-5 h-5 text-emerald-500" />
            </div>
            <h1 className="font-display text-3xl font-bold tracking-tight mb-1">Admin sign in</h1>
            <p className="text-sm text-muted-foreground">Restricted area — for site operators only.</p>
          </div>

          <form onSubmit={submit} className="bg-card border border-border rounded-2xl p-6 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Email</label>
              <input
                type="email"
                data-testid={ADMIN.emailInput}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1.5 w-full bg-background border border-border rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-emerald-500/60 transition"
                placeholder="admin@shouldibuyit.co.uk"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Password</label>
              <input
                type="password"
                data-testid={ADMIN.passwordInput}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1.5 w-full bg-background border border-border rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-emerald-500/60 transition"
                placeholder="••••••••"
              />
            </div>
            {err && <div className="text-xs text-red-400">{err}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid={ADMIN.loginBtn}
              className="w-full py-3 rounded-xl bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold text-sm flex items-center justify-center gap-2 transition disabled:opacity-50"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              Sign in
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
